export const gridData =
[{'id': 1,
  'Code1': 'M1V',
  'Code1_name':'Velocity of M1 Money Stock', 
  'Code2': 'WM1NS',
  'Code2_name':'M1', 
  'Date': '2023-12-31',
   'Static_Correlation': -0.980043}, 
  {'id': 2,
  'Code1': 'M1V',
  'Code1_name':'Velocity of M1 Money Stock',
   'Code2': 'DPSACBW027SBOG',
   'Code2_name':'Deposits, All Commercial Banks',
   'Date': '2023-12-31', 
   'Static_Correlation': -0.966191
  }, 
  {'id': 3,
  'Code1': 'M1V',
  'Code1_name':'Velocity of M1 Money Stock', 
  'Code2': 'WM2NS', 
  'Code2_name':'M2',
  'Date': '2023-12-31', 
  'Static_Correlation': -0.965277
 }  , 
  {'id': 4,
  'Code1': 'CURRDD',
  'Code1_name':'Currency Component of M1 Plus Demand Deposits',
   'Code2': 'M1V',
    'Code2_name':'Velocity of M1 Money Stock',
    'Date': '2023-12-31', 
    'Static_Correlation': -0.932541
  }, 
  {'id': 5,
  'Code1': 'A792RC0Q052SBEA',
  'Code1_name':'Personal income per capita', 
  'Code2': 'M1V',
  'Code2_name':'Velocity of M1 Money Stock',
  'Date': '2023-12-31',
  'Static_Correlation': -0.930763
  },
   {'id': 6,
   'Code1': 'CES0500000011',
   'Code1_name':'Average Weekly Earnings of All Employees, Total Private',
    'Code2': 'M1V',
    'Code2_name':'Velocity of M1 Money Stock',
     'Date': '2023-12-31', 
     'Static_Correlation': -0.926741
    }, 
   {'id': 7,
   'Code1': 'PI',
   'Code1_name':'Personal Income', 
   'Code2': 'M1V',
   'Code2_name':'Velocity of M1 Money Stock', 
   'Date': '2023-12-31', 
   'Static_Correlation': -0.920844
  }, 
   {'id': 8,
   'Code1': 'DSPI',
   'Code1_name':'Disposable Personal Income',
    'Code2': 'M1V',
    'Code2_name':'Velocity of M1 Money Stock',
    'Date': '2023-12-31',
    'Static_Correlation': -0.912322
    }, 
   {
    'id': 9,
    'Code1': 'RPI',
    'Code1_name':'Real Personal Income',
     'Code2': 'M1V',
     'Code2_name':'Velocity of M1 Money Stock',
      'Date': '2023-12-31',
   'Static_Correlation': -0.883886
  }, 
  {
    'id': 10,
    'Code1': 'CPILFESL',
    'Code1_name':'Consumer Price Index for All Urban Consumers: All Items Less Food and Energy in U.S. City Average',
    'Code2': 'M1V',
    'Code2_name':'Velocity of M1 Money Stock',
    'Date': '2023-12-31',
    'Static_Correlation': -0.868773
  },
  {
    'id': 11,
    'Code1': 'PI',
     'Code1_name':'Personal Income',
     'Code2': 'CES0500000011',
     'Code2_name':'Average Weekly Earnings of All Employees, Total Private',
      'Date': '2023-12-31',
    'Static_Correlation': 0.987684
  },
  {
    'id': 12,
    'Code1': 'CPILFESL',
    'Code1_name':'Consumer Price Index for All Urban Consumers: All Items Less Food and Energy in U.S. City Average',
    'Code2': 'CES0500000011',
    'Code2_name':'Average Weekly Earnings of All Employees, Total Private',
    'Date': '2023-12-31',
    'Static_Correlation': 0.98789
    },
  {
    'id': 13,
    'Code1': 'DSPI',
    'Code1_name':'Disposable Personal Income',
    'Code2': 'A792RC0Q052SBEA',
    'Code2_name':'Personal income per capita',
    'Date': '2023-12-31',
    'Static_Correlation': 0.990709
},
  {
  'id': 14,
  'Code1': 'CES0500000011',
  'Code1_name':'Average Weekly Earnings of All Employees, Total Private',
  'Code2': 'A792RC0Q052SBEA',
  'Code2_name':'Personal income per capita',
  'Date': '2023-12-31',
  'Static_Correlation': 0.991185
  },
  {'id': 15,
  'Code1': 'CPILFESL',
  'Code1_name':'Consumer Price Index for All Urban Consumers: All Items Less Food and Energy in U.S. City Average',
   'Code2': 'CES0500000017',
   'Code2_name':'Indexes of Aggregate Weekly Payrolls of All Employees, Total Private',
    'Date': '2023-12-31',
     'Static_Correlation': 0.993032
    },
  {
    'id': 16,
    'Code1': 'RPI',
    'Code1_name':'Real Personal Income',
     'Code2': 'DSPIC96',
     'Code2_name':'Real Disposable Personal Income',
      'Date': '2023-12-31',
       'Static_Correlation': 0.994271
      },
  {
    'id': 17,
    'Code1': 'PI',
    'Code1_name':'Personal Income',
     'Code2': 'A792RC0Q052SBEA',
     'Code2_name':'Personal income per capita',
      'Date': '2023-12-31',
       'Static_Correlation': 0.994794
  },
  {
    'id': 18,
    'Code1': 'PI',
     'Code1_name':'Personal Income',
     'Code2': 'DSPI',
     'Code2_name':'Disposable Personal Income',
      'Date': '2023-12-31',
       'Static_Correlation': 0.997833
  },
  {
    'id': 19,
    'Code1': 'PAYEMS',
    'Code1_name':"All Employees, Total Nonfarm",
     'Code2': 'CES0000000010',
      'Code2_name':'Women Employees, Total Nonfarm',
       'Date': '2023-12-31',
        'Static_Correlation': 0.99858
  }, 
  {
    'id': 20,
    'Code1': 'WM2NS',
     'Code1_name':'M2',
     'Code2': 'DPSACBW027SBOG',
      'Code2_name':'Deposits, All Commercial Banks',
      'Date': '2023-12-31',
       'Static_Correlation': 0.999343}
]


